import Button from "@mui/material/Button";
import { useWebRouter } from "~utils/next-router/use-web-router";

export function ButtonCancel() {
	const router = useWebRouter();
	return (
		<Button
			color="secondary"
			onClick={router.back}>
			Cancel
		</Button>
	);
}
